module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Tips #tips":{"hooks.onHandleErrorToggle":[{"value":function (data) {
var state = data.state;
fox.dom[state ? 'removeClass' : 'addClass']('error', data.el.parentNode)
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Tips #tips","_fox_":1}]},"~.SitePage_Tips #tips #tipItems #list":{"hooks.onAddedToDom":[{"value":function () {
$(this.element[0]).mCustomScrollbar({
theme: 'infinity',
});
this.wom1('@parent @parent')._updateForm();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Tips #tips #tipItems #list","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/tips.js
// module id = 1037
// module chunks = 4